import { Page } from '../../types'
import ExternalLink from '../../../components/ExternalLink'

type TricksGurobipyProps = { }

const render = () => {
    const tab = '\t'
    return <>
        <h3>Exporting a model</h3>
        <p>
            To write your mathematical model to a file, simply use <code>model.write('filename')</code>. Gurobi will
            automatically recognize the file extension to understand what <ExternalLink href="https://www.gurobi.com/documentation/{version]/refman/model_file_formats.html">file format</ExternalLink> you intend to use.
            Common formats include MPS, LP and REW. You may also add <code>.zip/.bz2/.gz/.7z</code> to compress your file.
            Read more in the <ExternalLink href="https://www.gurobi.com/documentation/{version}/refman/py_model_write.html">API reference</ExternalLink>.
        </p>
        <h3>Customizing the Gurobi environment</h3>
        <p>
            To set custom parameters on your Gurobi Environment, pass them to the 
            constructor and start your environment explicitly. Note how we're 
            using <ExternalLink href='https://book.pythontips.com/en/latest/context_managers.html'>context managers</ExternalLink> to
            automatically dispose the environment and model.
            <pre>
                import gurobipy as gp<br/>
                with gp.Environment(params={"{...}"}) as env:<br/>
                {tab}with gp.Model(env=env) as model:<br/>
                {tab}{tab}# Build and solve your model
            </pre>
        </p>
        <h3>Setting model parameters</h3>
        <p>
            The easiest way to set parameters is just to access them as a member 
            of <code>Model.Params</code>:
            <pre>model.Params.TimeLimit = 600</pre>
        </p>
        <h3>Disposing your environment</h3>
        <p>
            To explicitly dispose your environment and release any
            WLS or Token Server tokens, is as follows:
            <pre>
                model.dispose()<br/>
                env.dispose() # Only if you created an environment manually
            </pre>
        </p>
    </>
}

const TricksPyomo : Page<TricksGurobipyProps> = { title: 'Tips and tricks for Gurobipy', key: 'tricks-gurobipy', render }

export default TricksPyomo